import React from 'react'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { BottomSheet, Stack, XStack } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Icon } from '@zet/design-system/icons'
import Pressable from '@zet/design-system/pressable'
import { B2, SH1 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'

interface Props {
  isVisible: boolean
  setIsVisible: (visible: boolean) => void
  brandComms: any
  onContinue: (isSkipShareContentARNBottomsheet: boolean) => void
}
const ArnBottomSheet: React.FC<Props> = (props) => {
  const { isVisible, setIsVisible, brandComms, onContinue } = props

  const title =
    APP_NAME === MY_TEAMS_ADVISOR
      ? brandComms?.subAgentContent?.shareLinkConfirmation?.title
      : brandComms?.shareLinkConfirmation?.title
  const description =
    APP_NAME === MY_TEAMS_ADVISOR
      ? brandComms?.subAgentContent?.shareLinkConfirmation?.description
      : brandComms?.shareLinkConfirmation?.description

  return (
    <BottomSheet
      visible={isVisible}
      disableBottomSheet={() => setIsVisible(false)}
      onDismiss={() => setIsVisible(false)}
      sheetName="share_arn_card_link"
    >
      <>
        {!!title && (
          <XStack className="mx-3 my-3 justify-between">
            <Icon type="ErrorOutlined" size={24} />
            <SH1 className="ml-3 flex-1">{title}</SH1>
            <Pressable
              onPress={() => {
                setIsVisible(false)
              }}
            >
              <Icon type="Close" size={24} />
            </Pressable>
          </XStack>
        )}
        {!!description && (
          <Stack className="border-grays-30 border-b border-t px-3 py-3">
            <B2>{description}</B2>
          </Stack>
        )}
        <XStack className="mx-3 my-3 items-center justify-between">
          <Button className="w-full" size="lg" onPress={() => onContinue(true)}>
            {i18n.t('bottomView.continue')}
          </Button>
        </XStack>
      </>
    </BottomSheet>
  )
}

export default ArnBottomSheet
